import { render, staticRenderFns } from "./VObjectPuff.vue?vue&type=template&id=31fe8c4a&"
import script from "./VObjectPuff.vue?vue&type=script&lang=js&"
export * from "./VObjectPuff.vue?vue&type=script&lang=js&"
import style0 from "./VObjectPuff.vue?vue&type=style&index=0&id=31fe8c4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports